module.exports = __webpack_public_path__ + "static/media/capy_page_area01_img_cn@2x.08ff4106.png";